<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" placeholder="用户名/手机"/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
              <a-form-item label="日期区间">
                <a-range-picker
                  v-model="time_range_moment"
                  style="width: 100%"
                  format="YYYY-MM-DD HH:mm:ss"
                  :showTime="{
                  defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                  }"
                />
              </a-form-item>
            </a-col>

          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="调用次数">
                <a-input-number v-model="queryParam.callNo" style="width: 100%"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="更新日期">
                <a-date-picker v-model="queryParam.date" style="width: 100%" placeholder="请输入更新日期"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="使用状态">
                <a-select v-model="queryParam.useStatus" placeholder="请选择" default-value="0">
                  <a-select-option value="0">全部</a-select-option>
                  <a-select-option value="1">关闭</a-select-option>
                  <a-select-option value="2">运行中</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="使用状态">
                <a-select placeholder="请选择" default-value="0">
                  <a-select-option value="0">全部</a-select-option>
                  <a-select-option value="1">关闭</a-select-option>
                  <a-select-option value="2">运行中</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="false">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">

    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <span slot="name" slot-scope="name,record">
        <img :src="record.face" style="width: 40px; vertical-align: middle;" /> {{record.name}}
      </span>
       
      <span slot="action" slot-scope="text, record">
        <template >
          <a @click="handleLogManage(record)">复购客户</a>
          <a-divider type="vertical" />
        </template>
         
      </span>
    </s-table>

     

    <a-modal
        :maskClosable="false"
            title="明细管理"
            :width="1000"
            style="top: 20px;"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="scoreVisible"
            @ok="scoreVisible=false"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-table :columns="logColumns" :dataSource="logList" :pagination="scorePagination"
                   @change="handleLogTableChange"
                   rowKey="id" :scroll="{ y: 300 }" bordered>
            <template slot="footer" slot-scope="currentPageData">
              <div>
                <PriceInput  style="width: 200px; margin-right: 10px;" :formData="scoreFormData"
                             field="change"
                             placeholder="调整积分"/>
                <a-input style="width: 200px; margin-right: 10px;" v-model="scoreFormData.note" placeholder="请输入理由" />
                <!--</a-select>-->
                <a-button icon="edit" @click="scoreEdit" >修改积分</a-button>
              </div>
              <!-- <div style="margin: 10px 0 0 0">
                <PriceInput  style="width: 200px; margin-right: 10px;" :formData="blockFormData"
                             field="amount"
                             placeholder="冻结余额"/>
                <a-input style="width: 200px; margin-right: 10px;" v-model="blockFormData.note" placeholder="请输入理由" />
                <a-button icon="edit" @click="blockedEdit" >冻结余额</a-button>
              </div> -->
            </template>
          </a-table>
        </a-form>
      </a-spin>
    </a-modal>
  </a-card>
</template>

<script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import moment from 'moment'
  import areaOptions from '@/utils/area'

  import PriceInput from '@/components/PriceInput/'
  // import {  scoreLogList,scoreEdit } from '@/api/score'

  import RSwitch from '@/components/RSwitch/'
  import { getUserList  } from '@/api/purchase'

  import PicUploader from '@/components/PicUploader/'
  export default {
    name: 'OrderUserList',
    components: {
      AInput,
      ATextarea,
      RSwitch,
      STable,
      PriceInput,
      PicUploader
    },
    data () {
      return {
        areaOptions,
        time_range_moment:[],
        saveLoading:false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
        },
        groupOptions:[],
        formData:{
          can_apply_partner: 2,
          is_partner: 2,
          areas:[],
          weixin_pic:[],
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: 'id',
            sorter: true
          },
          {
            title: '用户名',
            width:"200px",
            dataIndex: 'name',
            scopedSlots: { customRender: 'name' },
          },
          {
            title: '手机号',
            dataIndex: 'phone'
          },
          {
            title: '销售订单数',
            dataIndex: 'sale_order_count',
            
          },
          {
            title: '成交笔数',
            dataIndex: 'sale_payed_order_count', 
          },
          {
            title: '成交金额',
            dataIndex: 'sale_payed_order_price', 
          },
          {
            title: '复购人数',
            dataIndex: 'sale_payed_user_count', 
          },
           
          {
            title: '操作',
            dataIndex: 'action',
            width: '150px',
            scopedSlots: { customRender: 'action' },
          }
        ],

        logList:[],

        //管理表头
        logColumns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '100px'
          },
          {
            title: '交易积分',
            width:'150px',
            dataIndex: 'change',
            customRender: (text) =>  {
              return parseFloat(text).toFixed(2);
            }
          },
          {
            title: '积分',
            width:'150px',
            dataIndex: 'score1',
            customRender: (text) =>  {
              return parseFloat(text).toFixed(2);
            }
          },
          {
            title: '类型',
            dataIndex: 'title',
            width:'100px',
          },
          {
            title: '附加信息',
            dataIndex: 'extra_note',
            width:'200px',
          },
          {
            title: '时间',
            dataIndex: 'create_time',
            customRender: (text) =>  {
              return moment(text*1000).format('YYYY-MM-DD HH:mm:ss');
            }
          },
        ],
        scoreVisible:false,
        scorePagination:{
            current: 1,
            pageSize:10,
            showTotal: (total) =>{
              return '总计'+total+'条'
            }
        },
        scoreQuery:{
          user_id:0,
          score:'score1',
          pageSize:10,
          pageNo:1
        },
        scoreFormData:{
          user_id:undefined,
          change:undefined,
          note:undefined
        },
        blockFormData:{
          account_id:undefined,
          amount:undefined,
          note:undefined
        },
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('loadData');
          console.log(this.queryParam);
          this.queryParam.user_group_ids = [];
           
          if (this.time_range_moment[0] && this.time_range_moment[1]) {
          this.queryParam.time_range = [
            this.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
            this.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
          ]
        } else {
          this.queryParam.time_range = []
        }
          this.queryParam = Object.assign(this.queryParam,parameter);
          return getUserList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
        },

        selectedRowKeys: [],
        selectedRows: [],
      }
    },
    created () {
//      getRoleList({ t: new Date()})
    },
    mounted(){
    let self = this;
      
    },
    methods: {
      moment ,
      handleLogManage(record) {
        return
        let self = this
        self.scoreQuery.user_id = record.id;
        self.scoreFormData.user_id=record.id
        self.scorePagination.current = 1;
        self.fetchLogList();
        this.scoreVisible = true
      },
      fetchLogList(){
        let self = this
        scoreLogList(self.scoreQuery).then(res => {
          self.logList = res.data.list

//          const pagination = { ...self.scorePagination };
          // Read total count from server
//           pagination.total = res.data.total;
          self.$set(self.scorePagination,'total',res.data.total);
//          self.scorePagination.total = res.data.total;
//          pagination.total = 200;
//          self.scorePagination = pagination;
        })
      },
      handleLogTableChange(pagination, filters, sorter){
        let that = this;
        that.scoreQuery.pageNo = pagination.current;
        that.$set(that.scorePagination,'current',pagination.current);
        that.fetchLogList();
      },
      scoreEdit(){
        let that = this;
        scoreEdit(that.scoreFormData).then(res => {
          that.$message.success('修改成功')
          that.fetchLogList();
          that.$refs.table.refresh()
          that.scoreVisible = false;
          that.scoreFormData = {
            user_id:undefined,
                    amount:undefined,
                    note:undefined
          };
        }).catch(err =>{
          that.$message.error(err.data.msg);
        })
      }, 
        // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },
      
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
      toggleAdvanced () {
        this.advanced = !this.advanced
      },

      resetSearchForm () {
        this.queryParam = {
          date: moment(new Date())
        }
      }
    },
    watch: {
      /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
    }
  }
</script>
